export default __webpack_public_path__ + "static/ProductSans-Regular-190f6362fb3d971a8fa3312e5bc2190f.woff";